import { put, takeEvery, all, putResolve } from "redux-saga/effects";
import { GET_ADHESION_STATUS, GET_CAMPAGNE_ATTIVE_SCREENING, GET_INVITE_REMINDER, GET_PROFILO_ARIANNA, GET_SCREENING_RESULT, PATCH_PROFILO_ARIANNA, POST_APPOINTMENT_CANCEL, POST_APPOINTMENT_CONFIRM } from "./actionsType";
import { getAdhesionStatusActionSuccess, getCampagneAttiveScreeningActionSuccess, getInviteReminderActionSuccess, getProfiloAriannaAction, getProfiloAriannaActionSuccess, getScreeningResultActionSuccess, postAppointmentConfirmActionSuccess } from "./actions";
import { LOADING, LOADING_BLOCKING } from "../../global/statusLabels";
import { TIMEOUT } from "../../api/api";
import { resetMessaggioStateAction, setMessaggioAction, setSnackbarAction } from "../messaggio/actions";
import { ERRORE_BLOCKING, ERRORE_GENERICO_API, ERRORE_SESSION_EXPIRED, ERRORE_UNAUTHORIZED, OPERATION_ERROR, OPERATION_SUCCEDED } from "../../global/messaggioLabels";
import { INVITISOLLECITICL, RIFIUTOCL } from "../../global/urlMapping";
import { getAdhesionStatusApiSPID, getAdhesionStatusApiTS, getCampagneAttiveScreeningApiTS, getInviteReminderApiSPID, getInviteReminderApiTS, getProfiloAriannaApiSPID, getProfiloAriannaApiTS, getScreeningResultApiSPID, getScreeningResultApiTS, patchProfiloAriannaApiSPID, patchProfiloAriannaApiTS, postAppointmentCancelApiSPID, postAppointmentCancelApiTS, postAppointmentConfirmApiSPID, postAppointmentConfirmApiTS } from "../../api/apiFunctionsScreening";
import { generaLog } from "../../functions/utils";
import { ASL_3, ASL_5 } from "../../global/multiAsl";


function* getProfiloAriannaWorker() {
    generaLog("getProfiloAriannaWorker", "log")
    yield put(getProfiloAriannaActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING_BLOCKING }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield getProfiloAriannaApiTS();
        }
        else {
            response = yield getProfiloAriannaApiSPID();
        }
        //TAPPULLO PER PATIENT = NULL response?.data?.patient !== null
        if (response?.status === 200 && response?.data?.patient !== null) {
            yield put(getProfiloAriannaActionSuccess({ value: response?.data, status: response?.status }))
            yield put(resetMessaggioStateAction())
        }
        else {
            yield put(getProfiloAriannaActionSuccess({ value: response?.data, status: 400 }))
            yield put(setMessaggioAction({ status: ERRORE_BLOCKING }))
        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_BLOCKING }))
        }
        yield put(getProfiloAriannaActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }
}

function* getProfiloAriannaWatcher() {
    yield takeEvery(GET_PROFILO_ARIANNA, getProfiloAriannaWorker);
}

function* patchProfiloAriannaWorker(body) {
    generaLog("patchProfiloAriannaWorker", "log")
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: TIMEOUT }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield patchProfiloAriannaApiTS(body.body)
        } else {
            response = yield patchProfiloAriannaApiSPID(body.body)
        }
        if (response?.status === 200) {
            yield putResolve(getProfiloAriannaAction())

            yield put(resetMessaggioStateAction())
            yield put(setSnackbarAction(OPERATION_SUCCEDED))
        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(resetMessaggioStateAction())
            yield put(setSnackbarAction(OPERATION_ERROR))
        }
    }
}

function* patchProfiloAriannaWatcher() {
    yield takeEvery(PATCH_PROFILO_ARIANNA, patchProfiloAriannaWorker);
}

function* getScreeningResultWorker(body) {
    generaLog("getScreeningResultWorker", "log")
    yield put(getScreeningResultActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield getScreeningResultApiTS(body.body)
        } else {
            response = yield getScreeningResultApiSPID(body.body)

        }
        if (response?.status === 200) {
            yield put(resetMessaggioStateAction())
            yield put(getScreeningResultActionSuccess({ value: response?.data, status: response?.status }))
        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(getScreeningResultActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }
}

function* getScreeningResultWatcher() {
    yield takeEvery(GET_SCREENING_RESULT, getScreeningResultWorker);
}

function* getAdhesionStatusWorker() {
    generaLog("getAdhesionStatusCLWorker", "log")
    yield put(getAdhesionStatusActionSuccess({ value: undefined, status: LOADING }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield getAdhesionStatusApiTS()
        } else {
            response = yield getAdhesionStatusApiSPID()

        }
        if (response?.status === 200) {
            yield put(getAdhesionStatusActionSuccess({ value: response?.data, status: response?.status }))
        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        }
        yield put(getAdhesionStatusActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }
}

function* getAdhesionStatusWatcher() {
    yield takeEvery(GET_ADHESION_STATUS, getAdhesionStatusWorker);
}
function* getInviteReminderWorker() {
    generaLog("getInviteReminderWorker", "log")
    yield put(getInviteReminderActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield getInviteReminderApiTS()
        } else {
            response = yield getInviteReminderApiSPID()

        }
        if (response?.status === 200) {
            yield put(resetMessaggioStateAction())
            yield put(getInviteReminderActionSuccess({ value: response?.data, status: response?.status }))
        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(getInviteReminderActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }
}

function* getInviteReminderWatcher() {
    yield takeEvery(GET_INVITE_REMINDER, getInviteReminderWorker);
}

function* postAppointmentCancelWorker(body) {
    generaLog("postAppointmentCancelWorker", "log")
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: TIMEOUT }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield postAppointmentCancelApiTS(body.body)
        } else {
            response = yield postAppointmentCancelApiSPID(body.body)

        }
        if (response?.status === 200) {
            yield put(resetMessaggioStateAction())
            yield put(setSnackbarAction(OPERATION_SUCCEDED))
            if (window.location.pathname === RIFIUTOCL)
                window.location.href = INVITISOLLECITICL

        }
    } catch (error) {
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else
            yield put(resetMessaggioStateAction())
        yield put(setSnackbarAction(OPERATION_ERROR))
    }
}

function* postAppointmentCancelWatcher(body) {
    yield takeEvery(POST_APPOINTMENT_CANCEL, postAppointmentCancelWorker);
}

function* postAppointmentConfirmWorker(body) {
    generaLog("postAppointmentConfirmWorker", "log")
    yield put(postAppointmentConfirmActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: TIMEOUT }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield postAppointmentConfirmApiTS(body.body)
        }
        else {
            response = yield postAppointmentConfirmApiSPID(body.body)
        }
        if (response?.status === 200) {
            yield put(postAppointmentConfirmActionSuccess({ value: response?.data, status: response?.status }))
            yield put(resetMessaggioStateAction())
            yield put(setSnackbarAction(OPERATION_SUCCEDED))
            window.location.href = INVITISOLLECITICL
        }
    } catch (error) {
        yield put(postAppointmentConfirmActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
        if (error?.response?.status === 401) {
            yield put(setMessaggioAction({ status: ERRORE_UNAUTHORIZED }))
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(resetMessaggioStateAction())
            yield put(setSnackbarAction(OPERATION_ERROR))
        }
    }
}

function* postAppointmentConfirmWatcher() {
    yield takeEvery(POST_APPOINTMENT_CONFIRM, postAppointmentConfirmWorker);
}


export function* screeningWatchers() {
    yield all([
        getProfiloAriannaWatcher(),
        patchProfiloAriannaWatcher(),
        getScreeningResultWatcher(),
        getAdhesionStatusWatcher(),
        getInviteReminderWatcher(),
        postAppointmentCancelWatcher(),
        postAppointmentConfirmWatcher(),
    ]);
}